function i18n(data) {
  var script = document.currentScript;
  if (!script) {
    var scripts = document.getElementsByTagName("script");
    script = scripts[scripts.length - 1];
  }
  var url = script.src;
  var m = url.match(/callback=([^&]*)/);
  if (m) {
    window[m[1]](data);
  } else {
    console.log('i18n load failed, script url:', url);
  }
}
